import cashFlowSchemaJson from '../../../../../shared/projection_cashflow_schema.json';

export type CfFormula =
    | { op: 'sum'; of: (string | number | CfFormula)[] }
    | { op: 'sub'; a: string | number | CfFormula; b: string | number | CfFormula }
    | { op: 'div'; a: string | number | CfFormula; b: string | number | CfFormula }
    | { op: 'delta'; key: string; sign?: 1 | -1 }
    | { op: 'lag'; key: string }
    | { op: 'ref'; key: string }
    | { op: 'const'; value: number }
    | string
    | number;

export interface CashFlowEntry {
    key: string;
    tab: 'CF';
    row: number | null;
    label: string;
    indent: number;
    kind: 'header' | 'line' | 'subtotal' | 'metric' | 'check';
    unit: 'usd' | 'count' | 'pct' | 'text';
    italic: boolean;
    formula: CfFormula | null;
    weight: string | null;
    driver_label: string;
    tone: string;
}

export function loadCashFlowSchema(): CashFlowEntry[] {
    return cashFlowSchemaJson as CashFlowEntry[];
}
